import { render, staticRenderFns } from "./workspaces.vue?vue&type=template&id=d0f85d6a&scoped=true&"
import script from "./workspaces.vue?vue&type=script&lang=ts&"
export * from "./workspaces.vue?vue&type=script&lang=ts&"
import style0 from "./workspaces.vue?vue&type=style&index=0&id=d0f85d6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0f85d6a",
  null
  
)

export default component.exports